<div [class.dark-theme]="true" class="fix-action-dialog">
	<div class="fix-action-dialog">
		<h2 mat-dialog-title style="font-size: 24px;color:#ffffff;font-weight: 600;"><span translate>パスワードの変更</span></h2>
		<h2 mat-dialog-title style="font-size: 14px;color:#ffffff;font-weight: 600;"><span translate>メールアドレス</span>：{{content.username}}</h2>
	</div>
	<mat-dialog-content fxLayout="column">
		<mat-card>
			<mat-card-content>
				<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
					<mat-form-field class="input-text">
						<mat-label><span data-idtest="guest-password-dialog-t-1Sb" translate>新しいパスワード</span></mat-label>
						<input data-idtest="guest-password-dialog-i-9Rg" #password="ngModel" [(ngModel)]="content.password" matInput maxlength="1000" minlength="6" name="password" placeholder="{{'新しいパスワード'| translate}}" required type="password">
						<mat-hint><span data-idtest="guest-password-dialog-t-3Yu" translate>6文字以上1000文字まで</span></mat-hint>
						<mat-error *ngIf="password.errors?.['required'];"><span translate>入力してください</span></mat-error>
						<mat-error *ngIf="password.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
						<mat-error *ngIf="password.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
					</mat-form-field>
					<mat-form-field class="input-text">
						<mat-label><span data-idtest="guest-password-dialog-t-2Fr" translate>同じパスワードをもう一度ご入力ください</span></mat-label>
						<input data-idtest="guest-password-dialog-i-8Fm" #confirm_password="ngModel" [(ngModel)]="content.confirm_password" [validateEquals]="password" matInput name="confirm_password" placeholder="{{'新しいパスワード(確認)'| translate}}" required type="password">
						<mat-hint><span data-idtest="guest-password-dialog-t-1Jq" translate>6文字以上1000文字まで</span></mat-hint>
						<mat-error *ngIf="confirm_password.errors?.['required'];"><span translate>確認用パスワードを入力してください</span></mat-error>
						<mat-error *ngIf="confirm_password.errors?.['validateEquals']"><span translate>確認用パスワードが一致しません</span></mat-error>
					</mat-form-field>
				</form>
			</mat-card-content>
		</mat-card>
	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-around" style="margin:6px;">
		<button data-idtest="guest-password-dialog-i-8Uq" [disabled]="isProgress" color="warn" mat-dialog-close="" mat-stroked-button id="mat-cancel-button"><span data-idtest="guest-password-dialog-t-5Yf" translate>キャンセル</span></button>
		<button (click)="onAccept()" [disabled]="form.invalid || isProgress" color="primary" mat-raised-button id="mat-ok-button"><span data-idtest="guest-password-dialog-t-6Rd" translate>更新</span></button>
	</mat-dialog-actions>
</div>
